__turbopack_context__.v({
  "accionIcono": "afiliacion-module__8hTrVG__accionIcono",
  "encabezado": "afiliacion-module__8hTrVG__encabezado",
  "espaciador": "afiliacion-module__8hTrVG__espaciador",
  "lista": "afiliacion-module__8hTrVG__lista",
  "nombre": "afiliacion-module__8hTrVG__nombre",
});
